import { useMutation, useQueryClient } from '@tanstack/react-query'
import { api, axiosConfig } from '../config'
import { ErrorWithResponse } from '../types'
import { toast } from 'react-toastify'


const madePayment = async () => {
  const config = axiosConfig()
  return await api.post('/operations/made-payment', config.formdata, config.config)
    .then((res) => res.data)
}

export const useMadePayment = () => {
  const queryClient = useQueryClient()

  return useMutation(madePayment, {
    onSuccess: () => {
      queryClient.invalidateQueries(['data'])
    },
    onError: (err: ErrorWithResponse) => {
      toast.error(err.response.data && err.response.data.description)
    },
  })
}
